module.exports = __webpack_public_path__ + "static/img/liantong.5bd7365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/liantong.jpg
// module id = mjxy
// module chunks = 0